import { createAsyncThunk } from "@reduxjs/toolkit";
import { Response } from "services/types";
import { GetUsersRequest } from "./types";
import { User } from "services/user/types";
import { UserService } from "services/user/user.service";
import { ThunkApiConfig } from "redux/types";

/**
 * Load Users by executing a remote API call.
 */
export const loadUsers = createAsyncThunk<Response<User[]>, GetUsersRequest, ThunkApiConfig>(
  "users/load",
  async () => {
    const service = new UserService();
    const response = await service.getUsers();

    return response;
  }
);

